/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Prepare_Item_2Inputs */

const en_how_we_work_prepare_item_2 = /** @type {(inputs: How_We_Work_Prepare_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The tools and people involved.`)
};

const lv_how_we_work_prepare_item_2 = /** @type {(inputs: How_We_Work_Prepare_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rīkus un cilvēkus, kas tajā iesaistīti.`)
};

/**
* | output |
* | --- |
* | "The tools and people involved." |
*
* @param {How_We_Work_Prepare_Item_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_prepare_item_2 = /** @type {((inputs?: How_We_Work_Prepare_Item_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Prepare_Item_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_prepare_item_2(inputs)
	return en_how_we_work_prepare_item_2(inputs)
});